import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyAvailability } from '@/features/my-availability'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-availability/'
)({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: MyAvailability,
})
